import APIService from "@utils/apiService";
import { getApiLocale } from "@translations/util";
import _ from "lodash";
import cx from "classnames";
class Service {
  config: any;
  constructor(config: any) {
    this.config = config;
  }
  async find(query: any) {
    // TODO Query.
    const handler: any = {
      string: async (id: string) => {
        return await APIService.get(`/api/rooms/${id}`);
      },
      number: async (id: string) => {
        return await APIService.get(`/api/rooms/${id}`);
      },
      object: async ({ id, ...params }: any) => {
        const { locale: routeLocale, ...restParams } = params;
        const apiLocale = routeLocale ? getApiLocale(routeLocale) : undefined;
        const requestParams = {
          ...restParams,
          ...(apiLocale !== undefined ? { locale: apiLocale } : {}),
        };
        return await APIService.get(`/api/rooms/${cx(id)}`, {
          params: requestParams,
        });
      },
    };
    const typeQuery = typeof query;
    if (_.isFunction(handler[typeQuery]))
      return await handler[typeQuery](query);
    return null;
  }
  async search(urlQuery: string) {
    const res = await APIService.get(`/api/rooms?${urlQuery}`);
    return res;
  }
}
const Model = new Service({});

export default Model;
